import { DatabaseRecord } from "@/core/repos/table.repo";
import { FeeLadderModel } from "../fee-ladder.model";

interface UnitTypeModelExt {
    provinceName?: string,
    feeLadder?: FeeLadderModel
}

export interface UnitTypeModel extends DatabaseRecord, UnitTypeModelExt {
    name: string;
    feeLadderId: string;
    provinceId: string;
    waterFactoryId: string;
    requiredDepositAmount: number;
    createdAt?: Date;
    updatedAt?: Date;
    createdBy?: string;
    updatedBy?: string;
    status: string;
}


export class UnitTypeModelFactory {
    static getEmpty(): UnitTypeModel {
        return {
            id: "",
            name: "",
            feeLadderId: "",
            provinceId: "",
            waterFactoryId: "",
            requiredDepositAmount: 0,
            createdAt: new Date(),
            updatedAt: new Date(),
            createdBy: "",
            updatedBy: "",
            status: ""
        };
    }
}
